module.exports = require("./dist/vue.js");


/*****************
 ** WEBPACK FOOTER
 ** vue (bower component)
 ** module id = 2
 ** module chunks = 0
 **/